import React, { useState, useEffect } from "react";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.svg";
import { history } from "../../helpers/history";
import clientmanagmentObj from "../../services/client-managment.service";
import depositService from "../../services/deposit.service";
import useBopayCanvas from "../../helpers/useBopayCanvas";
const Navigation = (props) => {
  const [activeClass, setActiveClass] = useState();
  const [depositcount, setDepositcount] = useState(0);
  const [changepincount, setChangepincount] = useState(0);
  const applyActiveClass = (id) => {
    setActiveClass(id);
  };

  // Paints the warm pink canvas while the admin shell is mounted.
  // Reference-counted so a screen that also claims it cannot strip it early.
  useBopayCanvas();

  const getCountAPIs = () => {
    depositService.getDepositCounts(
      "", "Pending", "0001-01-01", "0001-01-01", "0001-01-01", "0001-01-01", "", 1, ""
    ).then((resp) => {
      setDepositcount(resp?.data?.payload?.result?.totalCount);
    }).catch();
    clientmanagmentObj.getChangePinCount("", "", "0001-01-01T00:00:00.000Z", "0001-01-01T00:00:00.000Z", "", 1).then((resp) => {
      setChangepincount(resp?.data?.payload?.result?.totalCount)
    }).catch((error) => {

    });
  }

  useEffect(() => {
    setTimeout(() => {
      setActiveClass(window.location.pathname.replace("/", ""));
    }, 200);
    getCountAPIs();
  }, []);
  const closeLeftMenu = () => {
    if (document.getElementById("boMenu").classList.contains("bo-menu-overlay")) {
      document.getElementById("boMenu").classList.remove("bo-menu-overlay");
      document.getElementById("body").style = "overflow: visible";
      document.getElementById("leftNav").style.cssText =
        "position: unset; width: 0; height: 0; z-index: ; display : none";
    }
  }

  // One nav row. Keeps the classic <i> element so the icomoon glyphs still
  // render, and maps active state onto the new accent-bar class. `badge` is
  // rendered only when a count is supplied.
  const navItem = (id, to, icon, label, key, badge, extraOnClick) => (
    <li key={key || id}>
      <Link
        id={id}
        to={to}
        className={
          "bopay-nav-item" +
          (activeClass === key ? " bopay-nav-item--active" : "")
        }
        onClick={() => {
          applyActiveClass(key);
          closeLeftMenu();
          if (extraOnClick) extraOnClick();
        }}
      >
        <i className={icon}></i>{label}
        {badge !== undefined && badge !== null && (
          <span className="bopay-nav-badge">{badge}</span>
        )}
      </Link>
    </li>
  );

  const logoutBlock = (
    <Link
      to={"/login"}
      className="bopay-nav-logout"
      onClick={() => { props.logOut(); closeLeftMenu(); }}
    >
      <i className="icon-logout"></i>
      <span>
        Logout
        <span className="bopay-nav-username">{props.username}</span>
      </span>
    </Link>
  );

  return (
    <div className="col-lg-3 col-md-0 bo-sidebar-col bopay-nav" id="leftNav">
      <div className="bo-sidebar-outer">
        <div className="bopay-nav-head">
          <Link
            to="/dashboard"
            onClick={() => { applyActiveClass("dashboard"); closeLeftMenu(); }}
          >
            <div className="bopay-nav-wordmark">
              <span className="bopay-nav-wordmark-bo">bo</span>
              <span className="bopay-nav-wordmark-payments">payments</span>
            </div>
            <span className="bopay-nav-env">Super Admin</span>
          </Link>
        </div>
        {

        }
        <ul className="bopay-nav-list">
          {props.role !== null && (
            <Fragment>
              {(props.role.includes("Super admin")) ? (
                <Fragment>
                  {navItem("dashboardNavLink", "/dashboard", "icon-dashboard", "Dashboard", "dashboard", undefined, getCountAPIs)}
                  {navItem("cardsNavLink", "/cards", "icon-card", "Cards", "cards")}
                  {navItem("clientNavLink", "/clients", "icon-client", "Clients", "clients")}
                  {navItem("clientNavLink", "/superclients", "icon-client", "Super Clients", "superclients")}
                  {
                    props?.depositpermission && (
                      navItem("depositNavLink", "/deposit", "icon-deposit", "Deposit", "deposit", depositcount)
                    )
                  }
                  {navItem("moneyNavLink", "/sendmoney", "icon-transaction", "Send Money", "money")}
                  {
                    props?.rolemanagmentpermission && (
                      navItem("rolesNavLink", "/rolemanagment", "icon-RoleManagement", "Role Management", "rolemanagment")
                    )
                  }
                  {navItem("KeyNavLink", "/changepins", "icon-ChangePIN", "Change Pin", "changepins", changepincount)}
                  {navItem("KeyNavLink", "/declinetransactions", "icon-Wallet", "Decline Transaction", "declinetransactions")}
                  {
                    props?.FeeManagement &&(
                      <>
                      {navItem("FeeNavLink", "/feemanagments", "icon-Wallet", "Fee Management", "feemanagments")}
                      {navItem("NegativeTransactionsNavLink", "/negativetransactions", "icon-transaction", "Negative Balance(s)", "negativetransactions")}
                      {navItem("apikeymanagmentNavLink", "/apikeymanagment", "icon-settings", "API Key Managment", "apikeymanagment")}
                      {navItem("logrecordsNavLink", "/logrecords", "icon-settings", "Log Records", "logrecords")}
                      </>


                    )
                  }

                  {navItem("settingsNavLink", "/settings", "icon-settings", "Settings", "settings")}

                  <li className="bopay-nav-foot">
                    <hr className="bopay-nav-sep" />
                    {logoutBlock}
                  </li>

                </Fragment>
              ) : (
                <div>

                  {history.push("/login")}

                  {logoutBlock}
                </div>
              )}
            </Fragment>
          )}


        </ul>
      </div>
    </div>
  );
};
export default Navigation;
